import React, { useState, useEffect } from "react";
import {
    TextField,
    Button,
    IconButton,
    Typography,
    Box,
    FormControl,
    InputLabel,
    OutlinedInput,
    InputAdornment,
    Stack,
    useThemeProps,
} from "@mui/material";
import Logo from "../../assets/images/common/chat-logo.png";
import { useTheme } from '@mui/material/styles';
import { Newchat, Dropdown, Gemini, Chatlike, Chatdislike, Chatrefresh, Chatcopy, Sendmessege, Modalclose, Hamburguricon } from '../../icons/icons';
import Link from '@mui/material/Link';
import Autocomplete from '@mui/material/Autocomplete';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid2';
import { useDispatch, useSelector } from "react-redux";
import { ModelSelection } from "../../redux/chatslice";
import Indiaflag from "../../assets/images/login/india-flag.svg";
import Chatgpt from "../../assets/images/common/chatgpt-logo.png";
import Geminilogo from "../../assets/images/common/gemini-logo.png";
import Gemma from "../../assets/images/common/gemma-logo.png";
import Mistral from "../../assets/images/common/mistral-logo.png";
import Websearch from "../../assets/images/common/web-search-logo.png";
import Tick from "../../assets/images/common/tick-icon.png";

import Myaccount from "../dashboard/pages/myaccount";
import Mywallet from "../dashboard/pages/mywallet";
import MainChat from "../chat-dashboard/chatsidebar";


function Main({ selectedPage, toggleSidebar }) {
    const theme = useTheme();
    return (
        <>
            <Stack direction={'row'} alignItems={'center'} sx={{ p: { xs: '18px', sm: "20px  32px" }, borderBottom: '1px solid', borderBottomColor:'#0A43AE', }}>
                {/* <Button type="button" sx={{ p: 0, minWidth: 'auto', height: 'auto', display: { xs: 'block', sm: 'none' }, mr: '10px' }} onClick={toggleSidebar}>
                    <Hamburguricon />
                </Button> */}

                <Typography
                    variant="h2"
                    sx={{
                        color: theme.palette.secondary.main,
                        fontSize: "20px",
                        fontWeight: "700",
                    }}
                    fullWidth
                >
                </Typography>

                <Typography variant="h2" sx={{ color: theme.palette.secondary.main, fontSize: "20px", fontWeight: "700", }} fullWidth>
                    {selectedPage === "account" ? "My Account" :
                        selectedPage === "wallet" ? "My Wallet" : "Chat Page"}                </Typography>
            </Stack>


            {selectedPage === "account" && <Myaccount />}
            {selectedPage === "wallet" && <Mywallet />}
            {selectedPage === "/chat" && <MainChat />}
        </>
    );
}

export default Main;
